module.exports = __webpack_public_path__ + "img/img3.732352ba.png";